module.exports = __webpack_public_path__ + "img/1530305208.34353755.jpg";